import TutorialPage from "pages/tutorial/TutorialPage";

export default function TutorialRoute({ handleClose }: any) {
  return <TutorialPage handleClose={handleClose} />;
}
